import React from "react";

const SubscriptionCard = ({ subscription }) => {
  const formatAmount = (amount) => {
    if (!amount || amount === 0) return "Free";
    return `₹${parseFloat(amount).toLocaleString("en-IN")}`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getPlanDetails = (planName, planDisplayName) => {
    const plan = planName || subscription.plan_name;
    switch (plan) {
      case "trial":
        return { name: planDisplayName || "Trial Plan" };
      case "basic":
        return { name: planDisplayName || "Basic Plan" };
      case "advanced":
        return { name: planDisplayName || "Advanced Plan" };
      case "premium":
        return { name: planDisplayName || "Premium Plan" };
      default:
        return { name: planDisplayName || subscription.plan_display_name || "Unknown Plan" };
    }
  };

  const expiresAtDate = subscription.expires_at ? new Date(subscription.expires_at) : null;
  const isExpired = expiresAtDate ? expiresAtDate < new Date() : (subscription.status === "expired");
  const daysLeft = expiresAtDate
    ? Math.ceil((expiresAtDate - new Date()) / (1000 * 60 * 60 * 24))
    : 0;

  const isActive = !isExpired && (subscription.status === "active" || subscription.status === "completed");
  const planDetails = getPlanDetails(
    subscription.plan_name,
    subscription.plan_display_name
  );

  return (
    <div className="prof-sub">
      <div className="prof-sub-main">
        <span className={`ping-chip ${isActive ? "g" : subscription.status === "pending" ? "a" : subscription.status === "failed" ? "r" : "n"}`}>
          {isActive ? "Active" : subscription.status === "pending" ? "Pending" : subscription.status === "failed" ? "Failed" : "Expired"}
        </span>
        <div>
          <p className="prof-sub-name">{planDetails.name}</p>
          {subscription.payment_type && (
            <p className="prof-sub-meta">
              {subscription.payment_type === "upgrade" ? "Upgraded" : subscription.payment_type === "renewal" ? "Renewed" : "New"}
            </p>
          )}
        </div>
      </div>
      <div className="prof-sub-dates">
        <span>Started {formatDate(subscription.created_at)}</span>
        <span>Expires {formatDate(subscription.expires_at)}</span>
        {isActive && subscription.expires_at && (
          <span>{daysLeft > 0 ? `${daysLeft}d left` : "Expires today"}</span>
        )}
      </div>
      <div className="prof-sub-amt">{formatAmount(subscription.amount)}</div>
      {subscription.creditInfo && subscription.creditInfo.totalCredits > 0 && (
        <p className="prof-sub-credits">
          {subscription.creditInfo.totalAvailableReplies} AI replies
          {subscription.creditInfo.creditPlan
            ? ` · ${subscription.creditInfo.totalCredits} credits`
            : ""}
        </p>
      )}
    </div>
  );
};

export default SubscriptionCard;
